/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "detailView",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "#333333"
            },
            "detailView": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "11",
            "height": "11"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 11", className: "detailView", width: this.props.width, height: this.props.height },
            _react2["default"].createElement("path", { className: "st0", d: "M0 0h11v3H0zM0 8h11v3H0zM0 4h11v3H0z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/detailView.js